import { Flex } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import TableHeaderRow from "./components/TableHeaderRow";
import TableItemRow from "./components/TableItemRow";
import { RelatorioUnidadePessoa } from "core/features/relatorios/typings/index";
import { Empty } from "antd";
import { Skeleton } from "@chakra-ui/skeleton";

export interface TableRelatorioUnidadesProps {
  pessoas: RelatorioUnidadePessoa[];
  isLoading?: boolean;
}

export default function TableRelatorioUnidades({
  pessoas,
  isLoading,
}: TableRelatorioUnidadesProps) {
  return (
    <Flex
      maxW="100%"
      flexDir="column"
      overflowX="auto"
      className="custom-scroll-bar"
    >
      <Flex bg={colors.black100} gridGap={1} py={3} pr={6} fontWeight="medium">
        <TableHeaderRow />
      </Flex>

      <Flex maxW="100%" flexDir="column">
        {isLoading ? (
          <Flex flexDir="column" gap="1px">
            <Skeleton w="100%" h="70px" />
            <Skeleton w="100%" h="70px" />
          </Flex>
        ) : null}
        {!isLoading && !pessoas.length ? (
          <Flex my={2} w="100%" justifyContent="center">
            <Empty description="Sem pessoas cadastradas nessa unidade" />
          </Flex>
        ) : null}
        {pessoas.map((pessoa, index) => (
          <>
            <Flex
              key={pessoa.id}
              bg={index % 2 === 0 ? "white" : colors.black100}
              gridGap={1}
              py={3}
              pr={6}
              alignItems="center"
            >
              <TableItemRow pessoa={pessoa} />
            </Flex>
          </>
        ))}
      </Flex>
    </Flex>
  );
}
